import { Icon } from '@rsos/assets/icons';
import { DIGITAL_DISPATCH_INTEGRATIONS } from '@rsos/reduxDataStore/src/features/resourceRequests';

/**
 * What is being shared. Only the kind is threaded through the share flow —
 * each layer reads its own slice (emergencyCalls, incidents, resource
 * requests) via hooks, so the selected record never goes stale in props.
 */
export type ShareResource =
  | { kind: 'call' }
  | { kind: 'alert' }
  | {
      kind: 'resource_request';
      integration: typeof DIGITAL_DISPATCH_INTEGRATIONS.NORFOLK_SOUTHERN;
    };

export const CALL_RESOURCE: ShareResource = { kind: 'call' };
export const ALERT_RESOURCE: ShareResource = { kind: 'alert' };
export const NORFOLK_SOUTHERN_RESOURCE: ShareResource = {
  kind: 'resource_request',
  integration: DIGITAL_DISPATCH_INTEGRATIONS.NORFOLK_SOUTHERN,
};

/**
 * The subset of the alert record the share payload cares about. `useSelectedAlert`
 * is untyped JS and returns `{}` when nothing is selected, hence every field is
 * optional.
 */
/**
 * A taxonomy value on the alert record. The alerts API returns these as
 * objects, never bare strings — `{ display_name: 'Fire', name: 'FIRE' }`.
 */
export interface AlertTaxonomyValue {
  display_name?: string;
  name?: string;
}

export interface AlertLocation {
  civic?: Record<string, string | null>;
  geodetic?: { latitude?: number; longitude?: number };
  provided_location?: string;
  created_at?: number;
}

export interface SelectedAlert {
  alert_id?: string;
  emergency_type?: AlertTaxonomyValue;
  site_type?: AlertTaxonomyValue;
  service_provider_name?: string;
  subtype?: string;
  status?: AlertTaxonomyValue & {
    entity_display_name?: string;
    sender?: string;
  };
  location?: AlertLocation;
  /** Guaranteed by `normalizeAlerts` — derived from `location` when absent. */
  location_history?: AlertLocation[];
  incident_time?: number;
}

export interface Checkbox {
  label: string;
  description: string;
  isChecked: boolean;
  disabled?: boolean;
  id: string;
  icon?: Icon;
}
